import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import { useMemo } from "react";
import ScoreButton from "./ScoreButton";

type ScoreSectionProps = {
  innerHeight: number;
  score: number | null;
  selectScore: (score: number) => void;
};

export default function ScoreSection({ innerHeight, score, selectScore }: ScoreSectionProps) {
  const scoreArrangement = useMemo(() => {
    if (innerHeight <= 670) {
      return [
        [0, 1, 2],
        [3, 4, 5, 6, 7],
        [8, 9, 10],
      ];
    }
    return [
      [0, 1, 2, 3, 4],
      [5, 6, 7, 8, 9, 10],
    ];
  }, [innerHeight]);

  return (
    <div sx={{ maxWidth: 400, margin: RAW_cssValue("0 auto"), textAlign: "center" }}>
      {scoreArrangement.map((row) => (
        <div key={row.toString()}>
          {row.map((scoreOption) => (
            <ScoreButton key={scoreOption} scoreOption={scoreOption} selectedScore={score} selectScore={selectScore} />
          ))}
        </div>
      ))}
    </div>
  );
}
